var _defs, _rect, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTerminalIos = function SvgTerminalIos(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10.83 19.88",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:0.85px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.43,
    y: 0.43,
    width: 9.98,
    height: 19.03,
    rx: 1.62
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6,11.17a3.19,3.19,0,0,1-.35.63,3.35,3.35,0,0,1-.44.54.92.92,0,0,1-.58.25,1.4,1.4,0,0,1-.53-.13,1.54,1.54,0,0,0-.57-.12,1.63,1.63,0,0,0-.58.12A1.64,1.64,0,0,1,9,12.6a.87.87,0,0,1-.59-.26A3.5,3.5,0,0,1,8,11.78a3.92,3.92,0,0,1-.5-1,3.78,3.78,0,0,1-.2-1.17,2.14,2.14,0,0,1,.28-1.12,1.64,1.64,0,0,1,.58-.59A1.6,1.6,0,0,1,9,7.7a2,2,0,0,1,.61.14,1.7,1.7,0,0,0,.49.14,2.53,2.53,0,0,0,.54-.17,2,2,0,0,1,.73-.13,1.57,1.57,0,0,1,1.22.65,1.35,1.35,0,0,0-.72,1.23,1.31,1.31,0,0,0,.45,1,1.43,1.43,0,0,0,.44.3,2.49,2.49,0,0,1-.11.29ZM11.36,6.28a1.37,1.37,0,0,1-.36.91,1.19,1.19,0,0,1-1,.49.49.49,0,0,1,0-.12,1.4,1.4,0,0,1,.37-.91,1.37,1.37,0,0,1,.46-.35,1.19,1.19,0,0,1,.52-.14s0,.08,0,.12Z",
    transform: "translate(-4.59 -0.07)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTerminalIos, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/terminal-ios.8f11bfce.svg";
export { ForwardRef as ReactComponent };